export default "__VITE_ASSET__e2aafadf__"